import React from 'react';

const Modal = ({ show, handleClose, children }) => {
  const modalStyles = {
    display: show ? 'block' : 'none',
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    zIndex:1,
  };

  const contentStyles = {
    backgroundColor: '#fff',
    margin: '10% auto',
    padding: '20px',
    maxWidth: '80%',
    maxHeight: '80vh', // Set the max height of the modal
    overflowY: 'auto', // Add scroll when content overflows
  };

  return (
    <div style={modalStyles}>
      <div style={contentStyles}>
        {children}
        <button onClick={handleClose}>Close</button>
      </div>
    </div>
  );
};

export default Modal;
